import Cookies from "js-cookie";
import { useDispatch } from "react-redux";
import { getBaseUrl } from "../dataService";

export function useAuth() {
  const dispatch = useDispatch();
  return {
    set: (val) => {
      dispatch({
        type: "set",
        auth: {
          active: val,
        },
      });
    },

    permission: (obj) => {
      setCookie("active", true);
      const val = obj.data;
      var privilege = [];
      var role = [];
      for (var k in val) {
        if (typeof val[k] === "object" && val[k] !== null) {
          val[k].forEach((ele) => {
            privilege.push(ele);
          });
          role.push(k);
        }
      }
      dispatch({
        type: "set",
        role: role,
        privilege: privilege,
        auth: true,
      });
    },
  };
}

export const useSignOut = () => {
  return {
    /**
     * Sign out, locally and at Keycloak, in one navigation.
     *
     * Clearing local state is not enough on its own: the Keycloak SSO session outlives it, so the
     * next "Sign in with SSO" is answered silently and signs the person back in WITHOUT asking
     * for a password.
     *
     * Nothing here touches redux, and that is deliberate. Dispatching `clearStore` first makes
     * `App` re-render with `isAuthenticated` false, and `PrivateRoute`'s unauthenticated branch
     * runs its own `window.location.href = "https://main.eas-pro.my"` — which lands AFTER this
     * assignment and wins, so the browser goes to the marketing site and the Keycloak session is
     * never ended. The old code got away with it only because it called
     * `history.replace("/login")` first, which steered the guard to its no-op branch.
     *
     * There is nothing to tear down here anyway: the server expires the cookie, drops the Redis
     * entry and invalidates the session, the page is about to be replaced, and Login.js purges
     * the persisted store on mount.
     *
     * /account/oidc/logout is safe for a password-form session too — no `sid`, nothing stored, so
     * it clears the cookie and returns to /login without a Keycloak detour.
     */
    signOut: () => {
      // Safe to touch: cookies do not re-render anything. The token cookie the server writes is
      // httpOnly and is cleared server-side; this only removes a host-only leftover.
      setCookie("active", false);
      deleteCookie("token");
      window.location.href = getBaseUrl("eas") + "/account/oidc/logout";
      return Promise.resolve();
    },
  };
};

// When you use http://localhost:3001 for the frontend, your frontend and backend servers
//  share the same domain (even being on different ports), so you can see the cookie set
// by a request to your backend server (and so linked to backend server domain).
// When you use different domains, you just can't see the cookie as dev tools are attached
// to a page that belongs to another domain. But the cookie is saved and will be sent back with subsequent requests.

// different orign can't be set cookie, browser not receive it
export const getCookie = (key) => {
  return Cookies.get(key);
};

export const setCookie = (key, val) => {
  Cookies.set(key, val, { path: "/", sameSite: "Lax" });
};

// The path MUST match the one setCookie wrote with. js-cookie scopes removal by path, and a
// remove() without it silently deletes nothing -- the stale token keeps travelling on every
// request and the sign-out looks like it did not happen.
export const deleteCookie = (key) => {
  Cookies.remove(key, { path: "/" });
};
